import { render, staticRenderFns } from "./ClinicPageHeader.vue?vue&type=template&id=0b2d4707"
import script from "./ClinicPageHeader.vue?vue&type=script&lang=js"
export * from "./ClinicPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports